export function addProto(site: string) {
    return site.match(/^https?:\/\//) ? site : `https://${site}`;
}
